import BigNumber from 'bignumber.js';

BigNumber.config({
  /**
   * Always never return exponential notation
   * https://mikemcl.github.io/bignumber.js/#exponential-at
   */
  EXPONENTIAL_AT: 1e9,
});

// There is bug which prevents creating instances
// https://github.com/MikeMcl/bignumber.js/issues/251

const createInstance = (params: string | number | BigNumber): BigNumber =>
  params instanceof BigNumber ? params : new BigNumber(params);

export const BigNumberJs = createInstance;

export { BigNumber as BigNumberClass };
